// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ki-0";
export var assigneeDetails = "_ki-1";
export var assigneeInfo = "_ki-2";
export var dropdownContainer = "_ki-4";
export var dropdownImage = "_ki-5";
export var editAssigneeInfo = "_ki-3";
export var editAssigneeModalContainer = "_ki-6";
export var hidden = "_ki-8";
export var input = "_ki-7";